export function getDefaultSponsorPerProcessor(
	selectedProcessorId,
	processors,
	sponsors,
) {
	const defaultSponsorsMap = {
		[(processors?.find(x => x.name === "TSYS") || {}).id]:
			sponsors.find(x => x.name === "Esquire (prev. BBVA)") || {},
		[(processors?.find(x => x.name === "TSYS FSP") || {}).id]:
			sponsors.find(x => x.name === "BBVA FSP") || {},
		[(processors?.find(x => x.name === "Fiserv Omaha FSP") || {}).id]:
			sponsors.find(x => x.name === "Esquire (prev. BBVA)") || {},
		[(processors?.find(x => x.name === "Fiserv FSP") || {}).id]:
			sponsors.find(x => x.name === "BBVA FSP") || {},
		[(processors?.find(x => x.name === "Fiserv North") || {}).id]:
			sponsors.find(x => x.name === "KeyBank, N.A.") || {},
		[(processors?.find(x => x.name === "Fiserv Omaha Retail") || {}).id]:
			sponsors.find(x => x.name === "KeyBank, N.A.") || {},
		[(processors?.find(x => x.name === "Elavon") || {}).id]:
			sponsors.find(x => x.name === "US Bank") || {},
	};
	return defaultSponsorsMap[selectedProcessorId];
}

export function getDefaultPdfTemplatePerProcessor(
	selectedProcessorId,
	processors,
	pdfTemplates,
) {
	const defaultTemplatesMap = {
		[(processors?.find(x => x.name === "TSYS") || {}).id]:
			pdfTemplates.find(x => x.name === "FSPApplication") || {},
		[(processors?.find(x => x.name === "Fiserv Omaha FSP") || {}).id]:
			pdfTemplates.find(x => x.name === "FSPApplication") || {},
		[(processors?.find(x => x.name === "Fiserv North") || {}).id]:
			pdfTemplates.find(x => x.name === "FDNorthMPA") || {},
	};
	if (defaultTemplatesMap[selectedProcessorId] !== undefined) {
		return defaultTemplatesMap[selectedProcessorId].value;
	}
}
